// @flow

import * as React from "react";

type Props = {|
  +show: boolean,
  +onHide: () => void,
  +title?: React.Node,
  +children: React.Node,
  +footer?: React.Node,
  +wide?: boolean,
|};

function SimpleModal({show, onHide, title, children, footer, wide}: Props): React.Node {
  if (!show) {
    return null;
  }

  return (
    <div className="app-modal-overlay" onClick={onHide}>
      <div className={"app-modal-dialog" + (wide ? " app-modal-wide" : "")} onClick={(e) => e.stopPropagation()}>
        {title ? (
          <div className="app-modal-header">
            <div className="app-modal-title">{title}</div>
            <button className="app-modal-close" onClick={onHide}>&times;</button>
          </div>
        ) : null}
        <div className="app-modal-body">{children}</div>
        {footer ? <div className="app-modal-footer">{footer}</div> : null}
      </div>
    </div>
  );
}

export default SimpleModal;
